/* @flow */
import randomInt from 'random-int'

const ANIMATION_CLASS = 'animated-loading-background'

const heightPx = (height = 1) => `${height * 14}px`
const widthPercent = () => `${randomInt(30, 100)}%`

export const DataLoadingSkeletonString = () =>
  `<div
    class="${ANIMATION_CLASS} mt2"
    style="height: ${heightPx()}; width: ${widthPercent()};"
    ></div>`

export default {
  name: 'DataLoadingSkeleton',
  functional: true,
  render: (createElement: Function, {props: {height, width}, data}: Object) => {
    if (!data.style) data.style = {}
    if (!data.staticClass) data.staticClass = ''
    data.staticClass += ' ' + ANIMATION_CLASS
    data.style.height = heightPx(height)
    data.style.width = width || widthPercent()
    return createElement('div', data)
  },
}



// WEBPACK FOOTER //
// ./src/components/DataLoadingSkeleton.js